/*@ngInject*/
module.exports = function(classifiersService, roadElementsService, publicObjectsService, unitsService, accessibilityService) {
    return {
        scope: {
        },
        bindToController: true,
        controllerAs: 'vm',
        template: require('./road-element-search.directive.html'),
        controller: function() {
            let vm = this;
            vm.filter = {roadElementCategories: [], roadElementDifficultyLevels: [], showAkis: false, showOpis: false};
            vm.viewMode = "search";
            vm.roadElements = [];
            vm.parkingObjects = [];
            vm.publicTransportStopObjects = [];
            vm.showParkingObjects = false;
            vm.showPublicTransportStopObjects = false;
            vm.showError = false;
            vm.counties = [];
            vm.countiesLoading = true;
            vm.roadElementsLoading = true;

            vm.road_element_diff_level_easy_id = 416;
            vm.road_element_diff_level_medium_id = 417;
            vm.road_element_diff_level_hard_id = 418;

            vm.showPublicTransport = function () {
                vm.showPublicTransportStopObjects = !vm.showPublicTransportStopObjects;
            };

            vm.showParking = function() {
                vm.showParkingObjects = !vm.showParkingObjects;
            };

            accessibilityService.getByPageName('PATHS').then((res) =>{
                vm.roadElementsInfo = res.data;
            });

            publicObjectsService.getParkingObjects().then(function (response) {
                vm.parkingObjects = response.data;
            });

            publicObjectsService.getPublicTransportStopObjects().then(function (response) {
                vm.publicTransportStopObjects = response.data;
            });

            vm.categoryValueChange = function (val) {
                const idx = vm.filter.roadElementCategories.indexOf(val);
                if (idx > -1) {
                    vm.filter.roadElementCategories.splice(idx, 1);
                } else {
                    vm.filter.roadElementCategories.push(val);
                }
                vm.getRoadElementsBySearch();
            };

            vm.difficultyLevelValueChange = function (val) {
                const idx = vm.filter.roadElementDifficultyLevels.indexOf(val);
                if (idx > -1) {
                    vm.filter.roadElementDifficultyLevels.splice(idx, 1);
                } else {
                    vm.filter.roadElementDifficultyLevels.push(val);
                }
                vm.getRoadElementsBySearch();
            };

            vm.showAkis = function () {
                vm.filter.showAkis = !vm.filter.showAkis;
            };

            vm.showOpis = function() {
                vm.filter.showOpis = !vm.filter.showOpis;
            };

            vm.$onInit = function () {
                unitsService.getCountyList().then((response) => {
                    if (typeof response.data !== 'string') {
                        vm.counties = response.data;
                        vm.countiesLoading = false;
                    }
                });

                classifiersService.getRoadElementClassifiers().then(function (response) {
                    vm.roadElementCategories = response.data.roadElementCategories;
                    angular.forEach(vm.roadElementCategories, function (cat) {
                        vm.filter.roadElementCategories.push(cat.id);
                    });
                    vm.roadElementDifficultyLevels = response.data.roadElementDifficultyLevels;
                    angular.forEach(vm.roadElementDifficultyLevels, function (diffLevel) {
                        vm.filter.roadElementDifficultyLevels.push(diffLevel.id);
                    });

                    vm.getRoadElementsBySearch();
                });
            };

            vm.getRoadElementsBySearch = function() {
                vm.roadElementsLoading = true;
                roadElementsService.getRoadElementsSearch(vm.filter).then(function (result) {
                    vm.roadElementsLoading = false;
                    vm.roadElements = result.data;
                    vm.showError = !vm.roadElements || vm.roadElements.length === 0;
                });

                roadElementsService.getFilterAmountsByCounty(typeof vm.filter.county === 'undefined' ? '' : vm.filter.county).then(function (response) {
                    const diffLevelAndCatList = response.data;
                    angular.forEach(vm.roadElementCategories, function (cat) {
                        cat.count = vm.getCountFromList(cat.id, diffLevelAndCatList.categories);
                    });

                    angular.forEach(vm.roadElementDifficultyLevels, function (difficultyLevel) {
                        difficultyLevel.count = vm.getCountFromList(difficultyLevel.id, diffLevelAndCatList.difficultyLevels);
                    });
                });
            };

            vm.getCountFromList = function(id, list) {
                let count = 0;
                angular.forEach(list, function (elem) {
                    if (elem.id === parseInt(id)) {
                        count = elem.count;
                    }
                });
                return count;
            };

            vm.selectAll = () => {
                if (vm.isAllChecked()) {
                    vm.filter.roadElementCategories = [];
                    vm.filter.roadElementDifficultyLevels = [];
                } else {
                    vm.filter.roadElementCategories = [];
                    vm.filter.roadElementDifficultyLevels = [];
                    angular.forEach(vm.roadElementCategories, function (cat) {
                        vm.filter.roadElementCategories.push(cat.id);
                    });
                    angular.forEach(vm.roadElementDifficultyLevels, function (diffLevel) {
                        vm.filter.roadElementDifficultyLevels.push(diffLevel.id);
                    });
                }
                vm.getRoadElementsBySearch();
            };

            vm.isAllChecked = () => {
                if (typeof vm.roadElementCategories === 'undefined' || typeof vm.filter.roadElementCategories === 'undefined' ||
                    typeof vm.roadElementDifficultyLevels === 'undefined' || typeof vm.filter.roadElementDifficultyLevels === 'undefined') {
                    return true;
                }
                return vm.roadElementCategories.length + vm.roadElementDifficultyLevels.length === vm.filter.roadElementCategories.length + vm.filter.roadElementDifficultyLevels.length;
            };
        },
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/road_elements/road-element-search.directive.js
 **/